import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button";

const HeroSection = () => {
  const handleScrollToProjects = () => {
    const projectsSection = document.getElementById("featured-projects");
    if (projectsSection) {
      projectsSection?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleScrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      className="min-h-screen bg-gradient-to-br from-background via-muted/30 to-background flex items-center justify-center px-4 py-20"
    >
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        {/* Content Section */}
        <div className="text-center lg:text-left space-y-8">
          <div className="space-y-4">
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium">
              <Icon name="Sparkles" size={16} className="mr-2" />
              有木 祥子 のポートフォリオサイト
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                Shoko Ariki
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl text-text-secondary font-medium">
              FileMaker Developer
            </h2>

            <p className="text-lg text-text-secondary max-w-2xl leading-relaxed">
              岡山を拠点に、ファイルメーカーによるシステム開発・業務効率化をサポートしている「cue-lock（キューロック）」です。企業でのファイルメーカー制作の経験を活かし、地域の店舗や企業がインターネットの可能性を最大限に発揮できるよう、コンサルティング・企画提案も行っています。
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Button
              variant="default"
              size="lg"
              onClick={handleScrollToProjects}
              iconName="ArrowRight"
              iconPosition="right"
              className="hover-lift"
            >
              制作実績を見る
            </Button>

            {/* <Button
              variant="outline"
              size="lg"
              onClick={handleScrollToContact}
              iconName="Mail"
              iconPosition="left"
              className="hover-lift"
            >
              メールを送る
            </Button> */}
          </div>

          {/* Quick Stats */}
          <div className="flex flex-wrap gap-8 justify-center lg:justify-start pt-8">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">30+</div>
              <div className="text-sm text-text-secondary">
                Projects Completed
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">20+</div>
              <div className="text-sm text-text-secondary">
                Years Experience
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">20+</div>
              <div className="text-sm text-text-secondary">Happy Clients</div>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="flex justify-center lg:justify-end">
          <div className="relative">
            {/* Background Decorations */}
            <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-accent/20 rounded-full blur-2xl opacity-30"></div>
            <div className="absolute top-4 right-4 w-24 h-24 bg-primary/10 rounded-full blur-xl"></div>
            <div className="absolute bottom-4 left-4 w-32 h-32 bg-accent/10 rounded-full blur-xl"></div>

            {/* Profile Image */}
            <div className="relative w-80 h-80 md:w-96 md:h-96 rounded-full overflow-hidden shadow-elevation-lg hover-lift transition-layout">
              <Image
                src="https://portfolio.cue-lock.jp/image-folder/woman.png"
                alt="Sarah Johnson - Full-Stack Developer"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Floating Elements */}
            <div className="absolute top-8 left-8 bg-card shadow-elevation-md rounded-lg p-3 animate-pulse">
              <Icon name="Code" size={24} className="text-primary" />
            </div>

            <div className="absolute bottom-8 right-8 bg-card shadow-elevation-md rounded-lg p-3 animate-pulse">
              <Icon name="Palette" size={24} className="text-accent" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden md:flex md:absolute md:center md:bottom-0 md:-translate-x-1/2 md:w-full md:justify-center animate-bounce pointer-events-none">
        <div className="flex flex-col items-center space-y-2">
          <div className="text-sm text-text-secondary">Scroll to explore</div>
          <Icon name="ChevronDown" size={20} className="text-text-secondary" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
